export default "__VITE_ASSET__CMbAFGwF__"